module.exports = __webpack_public_path__ + "img/index-ico8.ba4d382e.png";